import { css } from 'styled-components';

import { colors } from '../utils';

export const datePickerOverwrite = css`
  .react-next-dates {
    --color-primary: ${colors.primary};

    &.popper {
      z-index: 11000;
    }
  }
`;
